const React = require('react');

const TableBody = require('../../../../dumb/TableBody');
const Col = require('../../../../dumb/Col/C');

const TableItem = require('./TableRow');

module.exports = ({data}) => {
  return (
    <div className="mt15 rlv hmin493">
      <div className="h abs sh st0 ov">
        <div className="abs s ov ovxA">
          <div className="wmin600 h rlv">
            <div className="bgE layoutRow fhaC fvaC r9 ov ph20 w1/6>1">
              <Col>Payment Mode</Col>
              <Col>External TRX ID</Col>
              <Col>Date</Col>
              <Col>Amount</Col>
              <Col>Lunu Fee</Col>
              <Col>Status</Col>
            </div>
            <div className="abs sh st45 sb ovH c0>.CircularProgress">
              <TableBody Item={TableItem} list={data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
